import ActionsSet from 'core/actions/ActionsSet'
import ListAction from 'core/actions/ListAction'
import CreateAction from 'core/actions/CreateAction'
import DeleteAction from 'core/actions/DeleteAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import ApiClient from 'api-client/ApiClient'
import store from 'app/store'
import { sessionStoreKey } from 'core/session/sessionReducers'
import { CreateApplicationCredentialParams, GetApplicationCredentialResponse } from './model'

const keystone = ApiClient.getInstance().keystone

const getUserId = (): string => {
  const state = store.getState()
  const { userDetails } = state[sessionStoreKey]
  return userDetails?.id || ''
}

export const applicationCredentialActions = ActionsSet.make<DataKeys.ApplicationCredentials>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.ApplicationCredentials,
  cacheKey: DataKeys.ApplicationCredentials,
})

export const listApplicationCredentials = applicationCredentialActions.add(
  new ListAction<DataKeys.ApplicationCredentials>(async () => {
    const userId = getUserId()
    if (!userId) {
      throw new Error('User ID not found in session')
    }
    return keystone.getAllApplicationCredentials({ userId })
  }),
)

export const createApplicationCredential = applicationCredentialActions.add(
  new CreateAction<DataKeys.ApplicationCredentials, CreateApplicationCredentialParams>(
    async (params) => {
      const userId = getUserId()
      if (!userId) {
        throw new Error('User ID not found in session')
      }
      const body = {
        application_credential: {
          name: params.name,
          ...(params.secret && { secret: params.secret }),
          ...(params.description && { description: params.description }),
          ...(params.expires_at && { expires_at: params.expires_at }),
          ...(params.roles && { roles: params.roles }),
          ...(params.unrestricted !== undefined && { unrestricted: params.unrestricted }),
          ...(params.access_rules?.length && { access_rules: params.access_rules }),
        },
      }
      return keystone.createApplicationCredentials({ userId, body })
    },
  ),
)

export const deleteApplicationCredential = applicationCredentialActions.add(
  new DeleteAction<DataKeys.ApplicationCredentials, { id: string }>(async ({ id }) => {
    const userId = getUserId()
    if (!userId) {
      throw new Error('User ID not found in session')
    }
    await keystone.deleteApplicationCredential({ userId, id })
  }),
)

export const getApplicationCredential = async (
  id: string,
): Promise<GetApplicationCredentialResponse> => {
  const userId = getUserId()
  if (!userId) {
    throw new Error('User ID not found in session')
  }
  return keystone.getApplicationCredential({ userId, id })
}
